<nh-form [formGroup]="getForm()" [mode]="mode" (validate)="onValidate($event)">
  <section [formGroup]="getControl('data')">
    <div class="container start-page">
      <div>
        <h1 class="section-header">Member Information</h1>
        <hr />
        <div class="d-flex align-items-center">
          <h2 class="person-label">Person Responsible for the Bill:</h2>
          <span class="ps-2 pb-1">{{ name }}</span>
        </div>
        <br />
        <div class="d-flex align-items-center">
          <h2 class="person-label">Client ID:</h2>
          <span class="ps-2 pb-1">{{ clientId }}</span>
        </div>
        <br />
        <div class="d-flex align-items-center">
          <h2 class="person-label">Case Number:</h2>
          <span class="ps-2 pb-1">{{ caseNumber }}</span>
        </div>
        <br />
        <p>
          Below are the incurred medical expenses that you have submitted in the
          past 3 months for this member.
        </p>
        <h2 class="section-header">Existing Medical Expenses</h2>
        <hr />
        @if (rows.length) {
        <ngx-datatable
          class="bootstrap striped"
          #table
          [rows]="rows"
          [limit]="5"
          [columnMode]="'force'"
          [headerHeight]="'auto'"
          [footerHeight]="50"
          [rowHeight]="'auto'"
        >
          @for (col of columnsA; track col) {
          <ngx-datatable-column [name]="col.name | translate" [prop]="col.prop">
          </ngx-datatable-column>
          }
          <ngx-datatable-column [width]="460">
            <ng-template let-column="column" ngx-datatable-header-template
              >Frequency</ng-template
            >
            <ng-template
              ngx-datatable-cell-template
              let-row="row"
              let-rowIndex="rowIndex"
            >
              @if (row && row.payFrequency.value !== null) {
              <div>
                <span>{{ row.payFrequency.value }}</span>
              </div>
              }
            </ng-template>
          </ngx-datatable-column>
          @for (col of columnsB; track col) {
          <ngx-datatable-column [name]="col.name | translate" [prop]="col.prop">
          </ngx-datatable-column>
          }
        </ngx-datatable>
        } @if (rows && rows.length) {
        <div class="pull-right">
          <p>Results Shown {{ rows.length }}</p>
        </div>
        } @if (!rows.length) {
        <p>
          This member does not have active incurred medical expenses. Click the
          <strong>Add Incurred Medical Expense</strong> hyperlink below to add
          an incurred medical expense.
        </p>
        }
        <div class="pt-1 hover-red text-start">
          <button
            class="btn btn-link btn-lg hover-red"
            role="link"
            style="padding-left: 0px"
            (click)="addIME()"
            aria-label="Add Incurred Medical Expense"
          >
            <span class="pe-2">Add Incurred Medical Expense</span>
            <nh-add-svg></nh-add-svg>
          </button>
        </div>
      </div>
    </div>
  </section>
</nh-form>